import React from 'react';
import { CircularProgress } from '@mui/material';
import { CenteredFlexBox } from '../../Components/FlexBox';

// Nothing is drawn for this long. A chunk already in memory resolves in a few
// milliseconds, and a spinner that appears and vanishes inside one frame reads
// as a glitch — worse than the blank it replaces. Long enough to swallow a warm
// navigation, short enough that a cold one still gets an answer quickly.
const APPEARS_AFTER_MS = 200;

/**
 * What fills the content area while a route's chunk downloads.
 *
 * Only reached on the FIRST visit to a page in a session: `React.lazy` memoizes
 * the module promise, so every later navigation to the same route resolves
 * synchronously and never suspends.
 *
 * Sized to the content area rather than the viewport, and mounted below the
 * sidebar and navbar, so the chrome stays put and nothing shifts when the page
 * arrives.
 */
const PageFallback = function PageFallback() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setVisible(true), APPEARS_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <CenteredFlexBox
      sx={{ width: '100%', height: '100%', justifyContent: 'center' }}
    >
      <CircularProgress size={28} />
    </CenteredFlexBox>
  );
};

export default PageFallback;
